<template>
    <AccountViewBase :account="account" :loading="loading" :error="error">
        <CompaniesManager :mode="mode" :id="id" />
    </AccountViewBase>
</template>

<script>
    import { mapState } from 'pinia';
    import AccountViewBase from '@/views/account/AccountViewBase';
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import accountMixin from '@/mixins/accountMixin';
    import CompaniesManager from '@/components/account/companies/CompaniesManager';
    import { useCompaniesStore } from '@/stores/companies';
    import { useProspectStore } from '@/stores/prospect';

    export default {
        name: 'CompanyView',
        components: {
            AccountViewBase,
            CompaniesManager
        },
        mixins: [i18nViewMixin, accountMixin],
        props: {
            mode: {
                type: String,
                required: false
            },
            id: {
                type: String,
                required: false
            }
        },
        data() {
            return {
                seo_title: 'views.company.seo_title',
                seo_title_data: null
            };
        },
        computed: {
            ...mapState(useCompaniesStore, {
                companiesMode: 'mode'
            }),
            ...mapState(useProspectStore, {
                prospect: 'prospect'
            }),
        },
        methods: {
            generateSeoTitle() {
                if(!this.prospect?.name) {
                    this.seo_title = 'views.company.seo_title';
                    this.seo_title_data = null;
                } else {
                    this.seo_title_data = {
                        name: this.prospect.name
                    };

                    switch (this.companiesMode) {
                        case 'new':
                            this.seo_title = 'views.company.seo_title_new';
                            break;
                        case 'prospects':
                            this.seo_title = 'views.company.seo_title_prospects';
                            break;
                        default:
                            this.seo_title = 'views.company.seo_title_all';
                            break;
                    }
                }
                this.updateDocumentTitle();
            }
        },
        watch: {
            companiesMode: 'generateSeoTitle',
            prospect: {
                handler(newVal) {
                    if (newVal) {
                        this.generateSeoTitle();
                    }
                },
                immediate: true
            },
        }
    }
</script>